






















































































import { getInitiativeStrategyMatrix } from "@/services";
import { InitiativeStrategyMatrix, InitiativeStrategyMatrixGoal } from "@/interfaces";
import { Component, Vue } from "vue-property-decorator";

import InitiativeStrategyMatrixDialog from "@/components/InitiativeStrategyMatrixDialog.vue";

@Component
export default class ObjectInitiativeMaps extends Vue {
  loading = false;
  matrixItems: InitiativeStrategyMatrix[] = [];

  mounted() {
    this.loadMatrix();
  }

  async loadMatrix() {
    try {
      this.loading = true;
      this.matrixItems = await getInitiativeStrategyMatrix();
      console.log(this.matrixItems);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  openList(item: InitiativeStrategyMatrixGoal, title: string) {
    this.$q.dialog({
      component: InitiativeStrategyMatrixDialog,
      item,
      title,
    });
  }

  get columns() {
    return [
      {
        name: "category",
        label: "Area obiettivo",
        field: "category",
        align: "left",
      },
      {
        name: "count",
        label: "Numero di iniziative",
        field: "count",
        align: "left",
      },
      { name: "list", align: "center" },
    ];
  }
}
